// Must NOT use the `trp_` prefix — src/main.jsx clears localStorage keys starting with `trp_` on version changes.
const PREFIX = 'certpro_free_used_v1_'

export function getFreeAttemptUsed(trackId) {
  try {
    return window.localStorage.getItem(`${PREFIX}${trackId}`) === '1'
  } catch {
    return false
  }
}

export function setFreeAttemptUsed(trackId) {
  try {
    window.localStorage.setItem(`${PREFIX}${trackId}`, '1')
  } catch {
    // ignore
  }
}

export function clearFreeAttemptUsed(trackId) {
  try {
    window.localStorage.removeItem(`${PREFIX}${trackId}`)
  } catch {
    // ignore
  }
}

const RECORD_PREFIX = 'certpro_last_record_v1_'

export function saveLastCertificateRecord(trackId, record) {
  try {
    window.localStorage.setItem(`${RECORD_PREFIX}${trackId}`, JSON.stringify(record))
  } catch {
    // ignore
  }
}

export function getLastCertificateRecord(trackId) {
  try {
    const raw = window.localStorage.getItem(`${RECORD_PREFIX}${trackId}`)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}
